module.exports = __webpack_public_path__ + "img/phone.52712f7f.svg";